/* ============
 * Pinia
 * ============
 *
 * The store of the application (SP-13864 — replaces Vuex).
 *
 * `setActivePinia()` is called on creation so the `useXxxStore()` composables
 * can also be used outside of a component — services, router guards, axios
 * interceptors — exactly like the Vuex singleton they replace. Every store
 * module imports this file for that side effect, so the order in which stores
 * are first touched never matters.
 *
 * https://pinia.vuejs.org/
 */

import { createPinia, setActivePinia } from 'pinia';

const pinia = createPinia();

setActivePinia(pinia);

export default pinia;
